import moment from "moment";
import { useCallback, useRef, useState } from "react";

import { useReactToPrint } from "react-to-print";
import { Spinner } from "reactstrap";

export const ButtonPrintSBUM2 = ({ innerRef, title }) => {
  const [loadingPrint, setLoadingPrint] = useState(false);
  const onBeforeGetContentResolve = useRef(null);

  const reactToPrintContent = useCallback(() => {
    return innerRef.current;
  }, [innerRef]);

  const handleAfterPrint = useCallback(() => {
    // tslint:disable-line no-console
  }, []);

  const handleBeforePrint = useCallback(() => {
    // tslint:disable-line no-console
  }, []);

  const handleOnBeforeGetContent = useCallback(() => {
    setLoadingPrint(true);
    return new Promise((resolve) => {
      onBeforeGetContentResolve.current = resolve;

      setTimeout(() => {
        setLoadingPrint(false);
        resolve();
      }, 2000);
    });
  }, [setLoadingPrint]);

  const handlePrint = useReactToPrint({
    content: reactToPrintContent,
    documentTitle: title,
    onBeforeGetContent: handleOnBeforeGetContent,
    onBeforePrint: handleBeforePrint,
    onAfterPrint: handleAfterPrint,
    removeAfterPrint: true,
  });

  return (
    <button
      type="submit"
      className="btn btn-item"
      onClick={() => {
        handlePrint();
      }}
    >
      CETAK &nbsp;{loadingPrint ? <Spinner size="sm" className="flex-shrink-0 ms-2" role="status"></Spinner> : ""}
    </button>
  );
};

export const PrintDocSBUM2 = ({ innerRef, item, companyName, companyValue }) => {
  const handleValidDate = (date) => {
    return moment(date).format("MMM D, YYYY");
  };

  function currencyFormat(num) {
    return parseFloat(num || 0).toLocaleString(["ban", "id"]);
  }

  return item === undefined || item === null ? (
    <></>
  ) : (
    <div
      className="d-none"
      style={{
        overflow: "scroll",
        //backgroundColor: "blue"
      }}
    >
      <div ref={innerRef} className="bg-white" style={{ padding: "40px 80px 40px 80px" }}>
        <div
          style={{
            textAlign: "center",
            fontSize: "18px",
            fontWeight: "bold",
          }}
        >
          SURAT PERMOHONAN SUBSIDI BANTUAN UANG MUKA
        </div>

        <div style={{ padding: "10px" }}>
          <p>
            Kepada Yth: <br />
            <span style={{ fontWeight: "bold" }}>Kepala Satuan Kerja Direktorat Jenderal Pembiayaan</span> <br />
            <span style={{ fontWeight: "bold" }}>Infrastruktur Pekerjaan Umum dan Perumahan</span>
            <br />
            Kementerian Pekerjaan Umum dan Perumahan Rakyat
            <br />
            Jalan Raden Patah 1 No 1 Gedung B Lantai 3<br />
            Kebayoran Baru, Jakarta Selatan 12110
            <br />
          </p>
          <p>Perihal : Permohonan Subsidi Bantuan Uang Muka Perumahan </p>
          <div style={{ marginBottom: "10px" }}>Saya yang bertanda tangan di bawah ini:</div>
          <table style={{ marginTop: "10px", borderCollapse: "collapse", tableLayout: "fixed", lineHeight: "1", width: "100%" }}>
            <tbody style={{ border: "1px solid black" }}>
              <tr style={{ border: "1px solid black" }}>
                <td style={{ verticalAlign: "top", width: "180px", padding: "4px 6px" }}>Nama</td>
                <td style={{ width: "15px", borderLeft: "1px solid black", padding: "4px 6px" }}>:</td>
                <td style={{ padding: "4px 6px" }}>{item.sls_appl?.name ?? "-"}</td>
              </tr>
              <tr style={{ border: "1px solid black" }}>
                <td style={{ padding: "4px 6px" }}>Tempat, Tanggal Lahir</td>
                <td style={{ borderLeft: "1px solid black", padding: "4px 6px" }}>:</td>
                <td style={{ padding: "4px 6px" }}>
                  {item.sls_appl?.birth_place ?? ""} , {handleValidDate(item.sls_appl?.birthat) ?? ""}
                </td>
              </tr>
              <tr style={{ border: "1px solid black" }}>
                <td style={{ padding: "4px 6px" }}>Pekerjaan</td>
                <td style={{ borderLeft: "1px solid black", padding: "4px 6px" }}>:</td>
                <td style={{ padding: "4px 6px" }}>{item.sls_appl?.job_desc ?? "-"}</td>
              </tr>
              <tr style={{ border: "1px solid black" }}>
                <td style={{ padding: "4px 6px" }}>No. KTP</td>
                <td style={{ borderLeft: "1px solid black", padding: "4px 6px" }}>:</td>
                <td style={{ padding: "4px 6px" }}>{item.sls_appl?.identity ?? "-"}</td>
              </tr>
              <tr style={{ border: "1px solid black" }}>
                <td style={{ verticalAlign: "top", width: "180px", padding: "4px 6px" }}>Alamat</td>
                <td style={{ width: "15px", borderLeft: "1px solid black", padding: "4px 6px" }}>:</td>
                <td style={{ padding: "4px 6px" }}>{item.sls_appl?.address ?? "-"}</td>
              </tr>
            </tbody>
          </table>

          <p style={{ marginTop: "10px" }}>mengajukan permohonan Subsidi Bantuan Uang Muka perumahan untuk pembelian Rumah Sejahtera Tapak dengan keterangan sebagai berikut:</p>
          <table style={{ marginTop: "10px", borderCollapse: "collapse", tableLayout: "fixed", lineHeight: "1", width: "100%" }}>
            <tbody style={{ border: "1px solid black" }}>
              <tr style={{ border: "1px solid black" }}>
                <td style={{ verticalAlign: "top", width: "180px", padding: "4px 6px" }}>Nama Pengembang</td>
                <td style={{ width: "15px", borderLeft: "1px solid black", padding: "4px 6px" }}>:</td>
                <td style={{ padding: "4px 6px" }}>{""}</td>
              </tr>
              <tr style={{ border: "1px solid black" }}>
                <td style={{ padding: "4px 6px" }}>Alamat Rumah yang Dibeli</td>
                <td style={{ borderLeft: "1px solid black", padding: "4px 6px" }}>:</td>
                <td style={{ padding: "4px 6px" }}>{""}</td>
              </tr>
              <tr style={{ border: "1px solid black" }}>
                <td style={{ padding: "4px 6px" }}>Harga Jual Rumah</td>
                <td style={{ borderLeft: "1px solid black", padding: "4px 6px" }}>:</td>
                <td style={{ padding: "4px 6px" }}>{""}</td>
              </tr>
              <tr style={{ border: "1px solid black" }}>
                <td style={{ padding: "4px 6px" }}>Besaran Uang Muka</td>
                <td style={{ borderLeft: "1px solid black", padding: "4px 6px" }}>:</td>
                <td style={{ padding: "4px 6px" }}>{""}</td>
              </tr>
              <tr style={{ border: "1px solid black" }}>
                <td style={{ padding: "4px 6px" }}>Bank Pelaksana</td>
                <td style={{ borderLeft: "1px solid black", padding: "4px 6px" }}>:</td>
                <td style={{ padding: "4px 6px" }}>{""}</td>
              </tr>
            </tbody>
          </table>
          <p style={{ marginTop: "10px" }}>Sebagai pertimbangan, bersama ini kami lampirkan dokumen fotokopi surat pengakuan kekurangan bayar uang muka pembelian Rumah Sejahtera Tapak yang disetujui oleh .................................*)</p>
          <p>Demikian kami sampaikan, atas perhatiannya kami ucapkan terima kasih</p>
        </div>
        <div style={{ display: "flex", justifyContent: "end" }}>
          <table
            style={{
              borderCollapse: "collapse",
              width: "350px",
              border: "1px solid black",
              tableLayout: "fixed",
            }}
          >
            <tbody>
              <tr>
                <td
                  colSpan={2}
                  style={{
                    border: "1px solid black",
                    padding: "12px",
                    textAlign: "center",
                    position: "relative",
                  }}
                >
                  ......................, tanggal ................ 20...
                  <br />
                  <small style={{ fontSize: "12px" }}>Kota/Kabupaten, tanggal bulan tahun</small>
                  <br /> <span style={{ fontWeight: "bold" }}>PEMOHON.</span>
                </td>
              </tr>
              <tr>
                <td
                  colSpan={2}
                  style={{
                    border: "1px solid black",
                    padding: "60px 12px 20px 12px",
                    textAlign: "center",
                  }}
                >
                  ( ..................................................... )
                  <br />
                  {item.sls_appl?.name ?? "-"}
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <p>*) diisi nama direktur/atau yang mewakili pengembang </p>
      </div>
    </div>
  );
};
